import { get } from 'lodash-es';
import { createSelector } from 'reselect';

import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

export const selectScales = (state) => get(state, 'scales', emptyArray);
export const selectDefaultScale = (state) => get(state, 'defaultScale');
export const selectPrinters = (state) => get(state, 'printers', emptyArray);
export const selectPrintJobs = (state) => get(state, 'printJobs', emptyArray);
export const selectWorkstations = (state) => get(state, 'workstations', emptyArray);

export const selectFlattenedPrinters = createSelector(selectPrinters, (printers) => {
  const flattened = printers.flatMap((group) => group.printers);
  return flattened.length === 0 ? emptyArray : flattened;
});

export const selectHasConnect = createSelector(selectWorkstations, (workstations) =>
  workstations.some((workstation) => workstation.isOnline),
);

export const selectWorkstationById = (state, { workstationId }) => {
  const workstations = selectWorkstations(state);
  return workstations.find((ws) => ws.workstationId === workstationId) || emptyObject;
};
